import { FormItem } from '@/interfaces/lib/model';
import { MultiLanguageItem, TextByLocale } from '@/lib/enum/MultiLanguageItem';
import { Locale } from '@/interfaces/api/general/language';

export class SignalWordId extends MultiLanguageItem {
  private static readonly _values: SignalWordId[] = [];

  static readonly NONE = new SignalWordId('NONE', {
    'en-US': 'None',
    'ja-JP': 'なし',
  });
  static readonly WARNING = new SignalWordId('WARNING', {
    'en-US': 'Warning',
    'ja-JP': '警告',
  });
  static readonly DANGER = new SignalWordId('DANGER', {
    'en-US': 'Danger',
    'ja-JP': '危険',
  });

  private constructor(readonly id: string, readonly text: TextByLocale) {
    super(id, text);
    SignalWordId._values.push(this);
  }

  static values(): SignalWordId[] {
    return SignalWordId._values;
  }

  static value(id: string, locale: Locale): string | undefined {
    return this.values()
      .find((signal) => signal.id === id)
      ?.value(locale);
  }

  static formItmes(locale: Locale): FormItem[] {
    return SignalWordId._values.map((x) => x.toFormItem(locale));
  }

  /**
   * convert value to word that is displayed to user
   *
   * NOTE
   * at 2025/8/31, It is expected that there are two types of value incoming (string, number)
   * but after migration, only number will exists
   *
   * @param value which should be translated (There are number or string types in migration stage)
   * @param locale locale that user use currently
   */
  static toWord(id: string | null): string {
    if (id === null) {
      return '';
    }

    // This will be removed after migration
    switch (id) {
      case SignalWordId.NONE.id:
        return 'なし';
      case SignalWordId.WARNING.id:
        return '警告 ; Warning';
      case SignalWordId.DANGER.id:
        return '危険 ; Danger';
      default:
        throw new Error(`Unknown SignalWordId: ${id}`);
    }
  }
}
